@if (showLdr) {
<ds-loading></ds-loading>
}

<!-- Modern Header Section -->
<div
  class="relative bg-gradient-to-br from-slate-50 via-violet-50 to-purple-50 shadow-xl border-b-4 border-violet-200 mb-4 overflow-hidden cstmmrgin"
>
  <div class="absolute inset-0 opacity-5">
    <div
      class="absolute top-0 left-0 w-96 h-96 bg-violet-500 rounded-full blur-3xl"
    ></div>
    <div
      class="absolute bottom-0 right-0 w-96 h-96 bg-purple-500 rounded-full blur-3xl"
    ></div>
  </div>
  <div class="relative flex items-center justify-between px-8 py-2">
    <div class="flex-1">
      <div class="flex items-center gap-3">
        <div
          class="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-violet-500 to-purple-600 rounded-xl shadow-lg flex items-center justify-center"
        >
          <svg
            class="w-6 h-6 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
            ></path>
          </svg>
        </div>
        <div>
          @if (clntDtls && clntDtls.length > 0 && clntDtls[0].clnt_id==7) {
          <h1
            class="text-xl font-bold bg-gradient-to-r from-violet-600 via-purple-600 to-violet-600 bg-clip-text text-transparent mb-0"
          >
            Ward Secretariat Wise Coverage Status @if (selectedtenantNm) {
            <span class="text-base text-purple-500 font-semibold ml-1"
              >({{ selectedtenantNm }})</span
            >
            }
          </h1>
          }
          <p class="text-sm text-gray-500 font-medium mb-1">
            ULB Level Ward Coverage Analytics
          </p>
        </div>
      </div>
    </div>
    <div class="flex items-center gap-3">
      @if (tntLst.length>1) {
      <div class="flex flex-col min-w-0" style="min-width: 180px">
        <nz-select
          class="filter-input"
          nzShowSearch
          [(ngModel)]="selectedtenant"
          (ngModelChange)="ontntSelect($event)"
          [ngModelOptions]="{ standalone: true }"
          style="width: 100%"
        >
          @for (t of tntLst; track t) {
          <nz-option
            [nzValue]="t.tnt_id"
            [nzLabel]="t.tnt_dsply_nm"
          ></nz-option>
          }
        </nz-select>
      </div>
      } @if (tntLst.length==1) {
      <span class="text-xs text-gray-500 font-medium">
        ULB:
        <span class="text-violet-600 font-semibold">{{
          tntLst[0].tnt_nm
        }}</span>
      </span>
      }
      <div class="flex flex-col min-w-0">
        <nz-date-picker
          [nzDisabledDate]="disabledDate"
          [nzFormat]="dateFormat"
          [(ngModel)]="slctdDt"
          (ngModelChange)="onChange($event)"
          class="filter-input"
        ></nz-date-picker>
      </div>
      <button
        (click)="goBack()"
        class="flex items-center gap-1.5 px-4 py-2 bg-gradient-to-r from-rose-500 to-red-600 hover:from-rose-600 hover:to-red-700 text-white rounded-lg transition-all duration-200 shadow-sm text-sm font-medium cursor-pointer border-0"
      >
        <span nz-icon nzType="left" nzTheme="outline"></span>
        Go Back
      </button>
    </div>
  </div>
  <div
    class="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-violet-400 via-purple-500 to-violet-500"
  ></div>
</div>

<div class="mx-auto px-3">
  <!-- Summary Strip -->
  @if (tdyCoveredTrips && tdyCoveredTrips.length > 0) {
  <div class="wulb-summary-strip">
    @for (d of tdyCoveredTrips; track d) {
    <div class="wulb-summary-item">
      <div class="wulb-item-icon bg-violet">
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
          ></path>
        </svg>
      </div>
      <div class="wulb-item-value">
        {{ d.TOT_VEHICLES === null ? "0" : d.TOT_VEHICLES }}
      </div>
      <div class="wulb-item-label">Total Vehicles</div>
    </div>
    }
    <div class="wulb-strip-divider"></div>
    @for (d of tdyCoveredTrips; track d) {
    <div class="wulb-summary-item">
      <div class="wulb-item-icon bg-amber">
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
          ></path>
        </svg>
      </div>
      <div class="wulb-item-value">
        {{ d.TOT_SVM === null ? "0" : d.TOT_SVM }}
      </div>
      <div class="wulb-item-label">Total Wards</div>
    </div>
    }
    <div class="wulb-strip-divider"></div>
    <div class="wulb-summary-item">
      <div class="wulb-item-icon bg-emerald">
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
          ></path>
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
          ></path>
        </svg>
      </div>
      <div class="wulb-item-value">
        {{
          rdrctUlbDtls.coverage_per === null ? 0 : rdrctUlbDtls.coverage_per
        }}%
      </div>
      <div class="wulb-item-label">Coverage %</div>
    </div>
  </div>
  }

  <!-- Zone wise Trip Coverage Table -->
  <div class="wulb-section-card">
    <div class="wulb-section-header">
      <div class="flex items-center gap-2">
        <svg
          class="w-5 h-5 text-violet-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
          ></path>
        </svg>
        <h2 class="wulb-section-title">Zone wise Trip Coverage Status</h2>
      </div>
    </div>
    <div class="wulb-grid-section">
      <app-data-grid
        [legacyTotalItems]="ttlColumnDefs"
        id="gridContainer"
        style="width: 100%"
        [dataSource]="tripsData"
        [legacyColumns]="columnDefs"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="true"
        exportFileName="ulb wise operated Trips"
        [pageSize]="10"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
        [wordWrapEnabled]="false"
        (cellClick)="devCellclk(columnDefs, $event)"
        [cellPrepared]="bound_onCellPrepared"
      >
      </app-data-grid>
    </div>
  </div>
</div>
